import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faImage, faTrash } from "@fortawesome/free-solid-svg-icons";

const NewItemPopup = ({
  show,
  onClose,
  onSave,
  productCategories,
  UomOptions,
  newItem,
  handleNewItemChange,
  vendors,
  productSubCategories = [],
  productGroups = []
}) => {

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col relative">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faTimes} className="w-5 h-5" />
        </button>

        {/* Title */}
        <h2 className="text-xl font-semibold p-6 pb-0 text-gray-800">
          Create New Item
        </h2>

        {/* === Scrollable Content === */}
        <div className="flex-1 overflow-y-auto px-6 pb-6 space-y-6">
          {/* === TOP SECTION === */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            {/* Left side - Item Info */}
            <div className="md:col-span-2 space-y-4">
              {/* Item Category */}
              <div className="flex items-center space-x-4">
                <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                  Item Category <span className="text-red-500">*</span>
                </label>
                <select
                  value={newItem.category?.value || ""}
                  onChange={(e) =>
                    handleNewItemChange("category", {
                      value: e.target.value,
                      label:
                        productCategories.find((c) => c._id === e.target.value)
                          ?.product_category_name || "",
                    })
                  }
                  className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                >
                  <option value="">Select Category</option>
                  {productCategories.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.product_category_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Subcategory, Group, Name, Vendor - each on a new line */}
              <div className="space-y-4">
                {/* Item Sub-Category */}
             <div className="flex items-center space-x-4">
  <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
    Item Sub-Category
  </label>
  <select
    value={newItem.subcategory?.value || ""}
    onChange={(e) =>
      handleNewItemChange("subcategory", {
        value: e.target.value,
        label: productSubCategories.find(sc => sc.id === e.target.value)?.label || ""
      })
    }
    className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
  >
    <option value="">Select Sub-Category</option>
    {productSubCategories.map((sc) => (
      <option key={sc.id} value={sc.id}>
        {sc.label}
      </option>
    ))}
  </select>
</div>


   <div className="flex items-center space-x-4">
  <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
    Vendor <span className="text-red-500">*</span>
  </label>
  <select
    value={newItem.vendor?.value || ""}
    onChange={(e) =>
      handleNewItemChange("vendor", {
        value: e.target.value, // ✅ vendor _id
        label: vendors.find((v) => v.id === e.target.value)?.label || "", // ✅ vendor name
      })
    }
    className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
  >
    <option value="">Select Vendor</option>
    {vendors.map((v) => (
      <option key={v.id} value={v.id}>
        {v.label}
      </option>
    ))}
  </select>
</div>


                {/* Item Group */}
            <div className="flex items-center space-x-4">
  <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
    Item Group
  </label>
  <select
    value={newItem.group?.value || ""}
    onChange={(e) =>
      handleNewItemChange("group", {
        value: e.target.value,
        label: productGroups.find(pg => pg.id === e.target.value)?.label || ""
      })
    }
    className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
  >
    <option value="">Select Group</option>
    {productGroups.map((pg) => (
      <option key={pg.id} value={pg.id}>
        {pg.label}
      </option>
    ))}
  </select>
</div>


                {/* Vendor */}
        
                {/* Item Name */}
                <div className="flex items-center space-x-4">
                  <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                    Item Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Item Name"
                    value={newItem.name}
                    onChange={(e) =>
                      handleNewItemChange("name", e.target.value)
                    }
                    className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>
            </div>

            {/* Right side - Image Upload */}
            <div className="flex flex-col items-center justify-center">
              <div className="w-40 h-40 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center bg-gray-50 relative">
                {newItem.image ? (
                  <>
                    <img
                      src={URL.createObjectURL(newItem.image)}
                      alt="Preview"
                      className="w-full h-full object-contain p-2 rounded-md"
                    />
                    <button
                      type="button"
                      onClick={() => handleNewItemChange("image", null)}
                      className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 text-xs"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </>
                ) : (
                  <div className="flex flex-col items-center text-gray-400">
                    <FontAwesomeIcon icon={faImage} className="w-10 h-10 mb-1" />
                    <p className="text-xs text-center">Upload Image</p>
                  </div>
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    handleNewItemChange("image", e.target.files[0])
                  }
                  className="absolute inset-0 opacity-0 cursor-pointer"
                />
              </div>
            </div>
          </div>

        

          {/* === REMAINING DETAILS === */}
          <div className="space-y-4">
            {/* SKU + HSN */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center space-x-4">
                <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                  SKU
                </label>
                <input
                  type="text"
                  placeholder="Enter SKU"
                  value={newItem.sku}
                  onChange={(e) => handleNewItemChange("sku", e.target.value)}
                  className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div className="flex items-center space-x-4">
                <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                  HSN Code
                </label>
                <input
                  type="text"
                  placeholder="Enter HSN Code"
                  value={newItem.hsnCode}
                  onChange={(e) =>
                    handleNewItemChange("hsnCode", e.target.value)
                  }
                  className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>

            {/* UOM */}
            <div className="flex items-center space-x-4">
              <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                UOM
              </label>
              <select
                value={newItem.uom?.value || ""}
                onChange={(e) =>
                  handleNewItemChange("uom", {
                    value: e.target.value,
                    label:
                      UomOptions.find((u) => u.value === e.target.value)
                        ?.label || "",
                  })
                }
                className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
              >
                <option value="">Select UOM</option>
                {UomOptions.map((u) => (
                  <option key={u.id} value={u.value}>
                    {u.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Tax Preference */}
            <div className="flex items-center space-x-4">
              <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                Tax Preference
              </label>
              <select
                value={newItem.taxPreference || ""}
                onChange={(e) =>
                  handleNewItemChange("taxPreference", e.target.value)
                }
                className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
              >
                <option value="">Select Tax Preference</option>
                <option value="Taxable">Taxable</option>
                <option value="Non-Taxable">Non-Taxable</option>
                <option value="Non-GST supply">Non-GST supply</option>
              </select>
            </div>

            {/* GST + IGST (if taxable) */}
            {newItem.taxPreference === "Taxable" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center space-x-4">
                  <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                    GST (%)
                  </label>
                  <input
                    type="number"
                    placeholder="GST %"
                    value={newItem.gst}
                    onChange={(e) =>
                      handleNewItemChange("gst", e.target.value)
                    }
                    className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                  />
                </div>
                <div className="flex items-center space-x-4">
                  <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                    IGST (%)
                  </label>
                  <input
                    type="number"
                    placeholder="IGST %"
                    value={newItem.igst}
                    onChange={(e) =>
                      handleNewItemChange("igst", e.target.value)
                    }
                    className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>
            )}
          </div>
          
        

          {/* === SALES & PURCHASE INFORMATION === */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
            {/* Sales Information Section */}
            <div>
              <h3 className="text-md font-semibold text-gray-800 mb-2">
                Sales Information
              </h3>
              <div className="flex items-center space-x-4">
                <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                  Selling Price
                </label>
                <input
                  type="number"
                  placeholder="Selling Price"
                  value={newItem.sellingPrice}
                  onChange={(e) =>
                    handleNewItemChange("sellingPrice", e.target.value)
                  }
                  className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>

            {/* Purchase Information Section */}
            <div>
              <h3 className="text-md font-semibold text-gray-800 mb-2">
                Purchase Information
              </h3>
              <div className="flex items-center space-x-4">
                <label className="text-sm font-medium text-gray-700 w-32 shrink-0">
                  Cost Price
                </label>
                <input
                  type="number"
                  placeholder="Cost Price"
                  value={newItem.costPrice}
                  onChange={(e) =>
                    handleNewItemChange("costPrice", e.target.value)
                  }
                  className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>
          </div>
          
        
          
          {/* Description */}
          <div className="flex items-start space-x-4">
            <label className="block text-sm font-medium text-gray-700 w-32 shrink-0 mt-1">
              Description
            </label>
            <textarea
              placeholder="Enter product description..."
              value={newItem.description}
              onChange={(e) =>
                handleNewItemChange("description", e.target.value)
              }
              rows="3"
              className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-400"
            />
          </div>
        </div>

        {/* === Footer Buttons === */}
        <div className="flex justify-start space-x-3 p-4 border-t bg-white">
       
          <button
            onClick={onSave}
            className="px-5 py-2 bg-red-500 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
          >
            Save
          </button>
             <button
            onClick={onClose}
            className="px-5 py-2 bg-gray-300 rounded-lg text-sm font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewItemPopup;